angular
	.module 'App.Repository'
	.factory 'InvoicedOrderRepository', ['BaseRepository', (BaseRepository) ->
		class InvoicedOrderRepository extends BaseRepository
			@resource = '/invoiced_orders'
			@isRestricted = true

		return new InvoicedOrderRepository
	]
